<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'shared.passwordDialog.title' | translate }}</p>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <span class="pe-1">
        {{ 'shared.passwordDialog.copyPassword' | translate }}
      </span>
      <a class="cursor-pointer" (click)="copyToClipboard(password)"
        ><span>{{ password }}</span> <i class="fa-light fa-copy ps-1"></i
      ></a>
    </div>
  </div>
  <div class="modal-footer py-2">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear me-2"
      (click)="close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
